import { render } from "./Hats.vue?vue&type=template&id=ec76a7e2"
import script from "./Hats.vue?vue&type=script&lang=js"
export * from "./Hats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__